import { render, staticRenderFns } from "./PMStructureAddCommentModal.vue?vue&type=template&id=7bf851a0&"
import script from "./PMStructureAddCommentModal.vue?vue&type=script&lang=ts&"
export * from "./PMStructureAddCommentModal.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureAddCommentModal.vue?vue&type=style&index=0&id=7bf851a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports